var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgId = function SvgId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.75 9.75h4.5m-4.5 3h2.52m5.48-3h2.5v3.5h-2.5zm-9 9.5h12.5a3 3 0 0 0 3-3v-8.5a3 3 0 0 0-3-3H5.75a3 3 0 0 0-3 3v8.5a3 3 0 0 0 3 3"
  })));
};
export default SvgId;